import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
// Redux
import IQuestion from 'models/Question';
import QuestionTypes from 'types/QuestionTypes';
import ConnectionsGrid from '../ConnectionsGrid';
import SimpleQuestion from '../SimpleQuestion';
import ImagePin from '../ImagePin';

type Props = {
  questionRef: string;
  defaultExpanded?: boolean;
}

const Question:FC<Props> = ({
  // Props
  questionRef, defaultExpanded
}) => {

  const { watch } = useFormContext();

  const watchedQuestions = watch('questions');
  const questionIndex = watchedQuestions.findIndex((question:any) => question.ref === questionRef);
  const question:IQuestion = watchedQuestions[questionIndex];

  if (questionIndex === undefined || questionIndex < 0) return null;
  
  if (question.type === QuestionTypes.ConnectionGrid) {
    return <ConnectionsGrid questionRef={questionRef} defaultExpanded={defaultExpanded} />
  }

  if (question.type === QuestionTypes.ImagePin) {
    return <ImagePin questionRef={questionRef} defaultExpanded={defaultExpanded} />
  }

  return <SimpleQuestion questionRef={questionRef} defaultExpanded={defaultExpanded} />
}

export default Question;
